import React, { useEffect, useState } from 'react';
import { Quill } from 'react-quill';
import './../../../node_modules/react-quill/dist/quill.snow.css';
import { defaultTooltipConfig, generateDropdown, onChange } from './helpers/TooltipHelper';
import { getTooltipOptions } from '../../editor/core-ui/tooltip/highed.tooltip.helper.utils';
import RichtextGroupWidget from './richtextgroup/RichtextGroupWidget';
import SeparatorWidget from './SeparatorWidget';

const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);

export default (props) => {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [headerDropdownValue, setHeaderDropdownValue] = useState();
  const [bodyDropdownValue, setBodyDropdownValue] = useState();

  useEffect(() => {
    const { chart } = props;

    if (chart) {
      chart?.update(defaultTooltipConfig, true);
      // Hover over tooltip point to get options for dropdown
      if (chart.series && chart.series[0] && chart.series[0].points.length) {
        chart.tooltip.refresh([chart.series[0].points[0]]);
      }

      const options = getTooltipOptions(chart.evervizTooltipOptions);
      setDropdownOptions(options);
    }
  }, []);

  const addValue = (variable, text) => {
    let getBody = (str) => new DOMParser().parseFromString(str, 'text/html').body;
    let node = getBody(variable);
    const firstNode = node.childNodes[0];
    const textNode = document.createTextNode(text);
    if (firstNode.tagName === 'SPAN') {
      const divNode = document.createElement('div');
      divNode.innerHTML = node.innerHTML;
      divNode.appendChild(textNode);
      return divNode.outerHTML;
    }
    node.appendChild(textNode);
    return node.innerHTML;
  };

  const addSelectedDropdownValue = (type, val) => {
    const { aggregatedOptions } = props;
    if (!val && (dropdownOptions ?? []).length) {
      // Probably selected first option
      val = dropdownOptions[0].value;
    }

    const mergeFieldText = '{' + val + '}';
    if (val) {
      if (type === 'header') {
        const value = addValue(aggregatedOptions.tooltip.headerFormat, mergeFieldText);
        onChange('headerFormat', { val: value });
      } else {
        const value = addValue(aggregatedOptions.tooltip.pointFormat, mergeFieldText);
        onChange('pointFormat', { val: value });
      }
    }
  };

  const onChangeText = (varName, newValue) => {
    const { userAggregatedOptions: aggregatedOptions } = props;
    onChange(varName, newValue, aggregatedOptions);
  };

  const headerDropdown = generateDropdown(
    dropdownOptions,
    setHeaderDropdownValue,
    headerDropdownValue,
    () => addSelectedDropdownValue('header', headerDropdownValue?.val),
    'Add data to header'
  );
  const bodyDropdown = generateDropdown(
    dropdownOptions,
    setBodyDropdownValue,
    bodyDropdownValue,
    () => addSelectedDropdownValue('point', bodyDropdownValue?.val),
    'Add data to body'
  );

  return (
    <>
      <div className="highed-tooltip-helper-container">
        <div className="highed-tooltip-helper-section-container">
          <RichtextGroupWidget
            option={{
              ...props.option,
              richtext: {
                ...props.option.richtext,
                type: 'headerFormat'
              }
            }}
            chart={props.chart}
            aggregatedOptions={props.aggregatedOptions}
            type={props.type}
            onChange={(val) => onChangeText('headerFormat', val)}
            label={'Header'}
          />
          {headerDropdown}

          <SeparatorWidget />

          <RichtextGroupWidget
            option={{
              ...props.option,
              richtext: {
                ...props.option.richtext,
                type: 'pointFormat'
              }
            }}
            chart={props.chart}
            aggregatedOptions={props.aggregatedOptions}
            type={props.type}
            onChange={(val) => onChangeText('pointFormat', val)}
            label={'Body'}
          />
          {bodyDropdown}
        </div>
      </div>
    </>
  );
};
